import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const CustomCheckboxGroup = ({ value, list, onChange }) => {
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    setSelectedValues(value ?? []);
  }, [value]);

  const handleChange = (event) => {
    const { value, checked } = event.target;
    onChange(
      checked
        ? [...selectedValues, value]
        : selectedValues?.filter((v) => v !== value)
    );
    setSelectedValues((prev) =>
      checked ? [...prev, value] : prev?.filter((v) => v !== value)
    );
  };

  return (
    <FormControl component="fieldset" variant="standard">
      <FormGroup>
        {list?.map((option) => (
          <FormControlLabel
            key={option?.value}
            sx={{ "& .MuiFormControlLabel-label": { marginLeft: "10px" } }}
            control={
              <Checkbox
                value={option?.value}
                checked={selectedValues?.includes(option?.value)}
                onChange={handleChange}
              />
            }
            label={option?.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

CustomCheckboxGroup.propTypes = {
  value: PropTypes.array,
  list: PropTypes.array,
};

CustomCheckboxGroup.defaultProps = {
  value: [],
  list: [],
};

export default CustomCheckboxGroup;
